{
  "0154a028a8dc3a3e": "Reglas y Expectativas",
  "0b074018a514be89": "Error al actualizar los mensajes automatizados para el primer turno. Por favor, inténtalo de nuevo más tarde.",
  "1509f561f2416598": "Guardar",
  "1651031bf58d8eea": "Regenerar",
  "19766ed6ccb2f4a3": "Cancelado",
  "1c344f753efd4691": "Tu mensaje ha sido actualizado.",
  "2f261331efb5e649": "Cuando está habilitado, envía a los profesionales que trabajan por primera vez un resumen de tus reglas 24 y 2 horas antes de su primer turno.",
  "322380c1273e3abd": "Tiene cambios no guardados. ¿Está seguro de que desea salir?",
  "413aa3282b04a4c8": "No pudimos cargar este mensaje. Por favor, intenta de nuevo.",
  "49e49bb4401e67bd": "Generar",
  "6533af23e0258a45": "Tus mensajes aún no han sido generados.",
  "6d9e92d79b8f2d3b": "Generando sus mensajes de recordatorio. Esto puede tardar un momento.",
  "6f38236b0918c7b0": "El mensaje no puede estar vacío.",
  "77ead13550b888df": "Reglas y Expectativas",
  "9a3999b7ebc7c547": "Editar mensaje de {{title}}",
  "9a39b66545015463": "Guardar cambios",
  "a58e3d6b07cf09f0": "El día antes del turno",
  "b6e8e2cee85d9d41": "Editar contenido del mensaje de {{title}}",
  "c4452f4d6323d651": "No pudimos comenzar a generar. Por favor, inténtelo de nuevo.",
  "c6e186268b29007e": "Sus reglas y expectativas han sido guardadas.",
  "cce7f995d327083a": "Habilitar mensajes automatizados para el primer turno",
  "d5b0a9c99513256f": "No pudimos guardar tus cambios. Por favor, inténtalo de nuevo.",
  "dcf57b1dfdd401b2": "2 horas antes del turno",
  "e963db70171393b6": "No pudimos generar este mensaje. Por favor, corrige cualquier problema que puedan contener tus reglas y vuelve a intentarlo.",
  "eadcb509d415d4c8": "Su nivel de permiso no le permite editar la información en esta página. Si desea editar esta página, puede pedir a su administrador que actualice su rol en la plataforma.",
  "f7ee7ef260e751b8": "Generando mensaje…"
}
